import './AnimatedHeight.css';
import React, { useRef, useEffect } from 'react';
import { nextAnimationFrame } from '../../util/util';
import GlobalProps from '../globalProps';
import classnames from 'classnames';

interface Props extends GlobalProps {
  minHeight?: string;
}

export function AnimatedHeight({ children, style, className, minHeight }: Props): JSX.Element {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const elementRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const container = containerRef.current;
    const element = elementRef.current;
    if (container && element) {
      nextAnimationFrame().then(() => {
        container.style.height = `${element.clientHeight}px`;
      });
    }
  });
  return (
    <div className={classnames('animated-height', className)} ref={containerRef} style={style}>
      <div ref={elementRef} style={{ minHeight }}>
        {children}
      </div>
    </div>
  );
}
